
import React from 'react';

export const PayInfoSection: React.FC<{ data: any }> = ({ data }) => {
    const isHourly = data.workType === 'HOURLY';

    const getHoursPerDay = (): number => {
        if (!data.workStartTime || !data.workEndTime) return 0;
        const [startH, startM] = data.workStartTime.split(':').map(Number);
        const [endH, endM] = data.workEndTime.split(':').map(Number);
        return (endH * 60 + endM - (startH * 60 + startM)) / 60;
    };

    const hoursPerDay = isHourly ? getHoursPerDay() : 0;
    const totalDays = data.totalDays || 0;
    // data.amount: 현재 코디네이터의 제안 급여 (지원한 경우에만 서버에서 내려옴)
    // data.additionalPay: 매칭 확정된 코디네이터의 금액
    // data.dailyPay: 공고 원래 기준 단가
    const baseAmount = data.amount || data.additionalPay || data.dailyPay || 0;
    const totalAmount = isHourly
        ? baseAmount * hoursPerDay * totalDays
        : baseAmount * totalDays;
    // 실제 적용 단가(제안/매칭)가 공고 원래 단가와 다르면 조정된 것 → 회원·코디 모두 표시
    const isAmountAdjusted = Number(data.dailyPay) > 0 && Number(baseAmount) !== Number(data.dailyPay);

    return (
        <section className="bg-white">
            <div className="inner-box">
                <h3 className="cont-tit"><span className="underline">돌봄 비용</span></h3>
                <div className="round-box mt10">
                    <div className="round-body">
                        <div className="info-row">
                            <span className="label">기준단가</span>
                            <span className="cont big-number">
                                {isHourly ? '시급' : '일급'} / {baseAmount.toLocaleString()}원
                                {data.negotiable && <span className="badge">{data.payNegotiable === 'Y' ? '제안 가능' : '제안 불가능'}</span>}
                                {isAmountAdjusted && <span className="badge" style={{marginLeft: '4px', background: '#ff8c00', color: '#fff'}}>제안</span>}
                            </span>
                        </div>
                        {isAmountAdjusted && (
                            <div className="info-row">
                                <span className="label">공고 원래 단가</span>
                                <span className="cont">{isHourly ? '시급' : '일급'} / {Number(data.dailyPay).toLocaleString()}원</span>
                            </div>
                        )}
                        <div className="info-row">
                            <span className="label">기간</span>
                            <span className="cont">
                                {totalDays}일
                                {isHourly && hoursPerDay > 0 && ` (총 ${Math.floor(totalDays * hoursPerDay)}시간)`}
                            </span>
                        </div>
                        <div className="info-row top-line">
                            <span className="label"><strong>총 결제금액</strong></span>
                            <span className="cont"><strong>{Math.floor(totalAmount).toLocaleString()}원</strong></span>
                        </div>
                    </div>
                </div>
                {data.payOption === 'adjust' && (
                    <div className="guide-box mt10">
                        <p className="guide_txt middle text-center">
                            {data.adjustDirection === 'add' ? '추가 조정' : '차감 조정'} :&nbsp;
                            <strong>
                                {data.adjustDirection === 'add' ? '+' : '-'} {data.adjustAmount?.toLocaleString()}원
                            </strong>
                            {data.isAdjustAccepted === true  && <span className="text-blue">[승인]</span>}
                            {data.isAdjustAccepted === false && <span className="text-red">[거절]</span>}
                            {data.isAdjustAccepted === null  && <span className="text-gray">[검토중]</span>}
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
};